export class WebAttribution {
    event_properties;
    event_type = "web_attribution";
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
